import { StandardEvents } from '@shopify/events';

class MMKDeliveryStatus extends HTMLElement {
  #scope;
  #version = 0;

  connectedCallback() {
    this.#scope = this.closest('.shopify-section, dialog');
    this.#scope?.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    this.#version += 1;
    this.#scope?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
    this.#scope = undefined;
  }

  #onSelect = event => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (event.target.closest('.shopify-section, dialog') !== this.#scope) return;
    if (!event.promise?.then) return;
    const version = ++this.#version;
    event.promise.then(({ detail } = {}) => {
      if (!this.isConnected || version !== this.#version) return;
      if (detail?.productId && String(detail.productId) !== this.dataset.productId && !detail.newProduct) return;
      const label = this.querySelector('[data-mmk-delivery-text]');
      if (!label) return;
      const candidates = detail?.html?.querySelectorAll('mmk-delivery-status[data-mmk-slot]') ?? [];
      const next = Array.from(candidates).find(node => node.dataset.mmkSlot === this.dataset.mmkSlot);
      if (!detail?.resource) {
        label.textContent = 'Wählen Sie bitte eine Variante.';
        if (next?.dataset.productId) this.dataset.productId = next.dataset.productId;
        return;
      }
      const nextLabel = next?.querySelector('[data-mmk-delivery-text]');
      if (!nextLabel) return;
      label.textContent = nextLabel.textContent;
      if (next.dataset.productId) this.dataset.productId = next.dataset.productId;
    }).catch(() => {});
  };
}

if (!customElements.get('mmk-delivery-status')) customElements.define('mmk-delivery-status', MMKDeliveryStatus);
